// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/period_summary/{id}
 *
 * Returns a summary of the payroll period including executions and linked
 * expenses. The three structurally-rich fields (`period`, `executions`,
 * `linked_expenses`) point at sibling Row classes so the Spatie TS pipeline
 * can project a typed interface for each, and `FF_STRICT_ROW_CONTRACTS=1`
 * catches drift if the source query gains a column that isn't declared on
 * the Row.
 */
import type { Payroll_PeriodSummaryExecutionRow } from './Payroll_PeriodSummaryExecutionRow'
import type { Payroll_PeriodSummaryLinkedExpenseRow } from './Payroll_PeriodSummaryLinkedExpenseRow'
import type { Payroll_PeriodSummaryPeriodRow } from './Payroll_PeriodSummaryPeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PeriodSummaryResponseDados {
period: Payroll_PeriodSummaryPeriodRow
executions: Payroll_PeriodSummaryExecutionRow[]
linked_expenses: Payroll_PeriodSummaryLinkedExpenseRow[]
total_executions: number
total_expenses: number
}

export type Payroll_PeriodSummaryResponse = ApiResponse<Payroll_PeriodSummaryResponseDados>;

registerResponseContract('Payroll_PeriodSummaryResponse', {
  period: {
    type: 'object',
    required: true,
    fields: {
      id:                           { type: 'number',  required: true },
      franchise_id:                 { type: 'number',  required: true },
      user_id:                      { type: 'string',  required: true },
      period_start_date:            { type: 'string',  required: true },
      period_end_date:              { type: 'string',  required: true },
      revenue_conciliation_amount:  { type: 'string',  required: true },
      expenses_conciliation_amount: { type: 'string',  required: true },
      status:                       { type: 'number',  required: true },
      total_amount:                 { type: 'string',  required: true },
      created_at:                   { type: 'string',  required: true },
      updated_at:                   { type: 'string',  required: true },
      calculated_at:                { type: 'string',  required: false },
      paid_at:                      { type: 'string',  required: false },
      paid_by:                      { type: 'string',  required: false },
    },
  },
  executions: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      payroll_period_id: { type: 'number',  required: true },
      payment_rule_id:   { type: 'number',  required: true },
      user_id:           { type: 'string',  required: true },
      franchise_id:      { type: 'number',  required: true },
      despesa_id:        { type: 'number',  required: false },
      base_amount:       { type: 'string',  required: true },
      revenue_tracked:   { type: 'string',  required: false },
      expenses_tracked:  { type: 'string',  required: false },
      total_deductions:  { type: 'string',  required: true },
      net_amount:        { type: 'string',  required: true },
      calculation_meta:  { type: 'string',  required: false },
      status:            { type: 'string',  required: true },
      paid_at:           { type: 'string',  required: false },
      created_at:        { type: 'string',  required: true },
      updated_at:        { type: 'string',  required: true },
      rule_type:         { type: 'string',  required: true },
      rule_amount:       { type: 'string',  required: true },
    },
  },
  linked_expenses: {
    type: 'array',
    required: true,
    items: {
      despesa_id:              { type: 'number',  required: true },
      despesa_titulo:          { type: 'string',  required: true },
      despesa_valor:           { type: 'string',  required: true },
      despesa_data_vencimento: { type: 'string',  required: true },
      despesa_data_lancamento: { type: 'string',  required: true },
      despesa_categoria_id:    { type: 'number',  required: true },
      categoria_nome:          { type: 'string',  required: true },
      status_nome:             { type: 'string',  required: true },
    },
  },
  total_executions: { type: 'number',  required: true },
  total_expenses:   { type: 'number',  required: true },
})
